// LegendaStatusVisita — legenda de cores das OS no mapa, com filtro clicável.
//
// Posicionada abaixo do mapa do dashboard. Cada pill mostra:
// bolinha colorida · label · contagem.
// Click filtra; click de novo desfaz; "Todos" reseta.
//
// Recebe:
//   resumo            — objeto { concluidas, em_andamento_no_horario, em_andamento_atrasada,
//                                proxima_2h, atrasadas, agendadas }
//   statusSelecionado — string | null
//   onChange(novo)    — callback (null = mostrar todos)

const ITENS = [
  { key: 'agendada',                label: 'Agendada',           cor: '#94a3b8', resumoKey: 'agendadas' },
  { key: 'proxima_2h',              label: 'Próxima 2h',         cor: '#fbbf24', resumoKey: 'proxima_2h' },
  { key: 'em_andamento_no_horario', label: 'Em andamento',       cor: '#3b82f6', resumoKey: 'em_andamento_no_horario' },
  { key: 'em_andamento_atrasada',   label: 'Em and. atrasada',   cor: '#f97316', resumoKey: 'em_andamento_atrasada' },
  { key: 'atrasada',                label: 'Atrasada',           cor: '#ef4444', resumoKey: 'atrasadas' },
  { key: 'concluida',               label: 'Concluída',          cor: '#22c55e', resumoKey: 'concluidas' },
];

export default function LegendaStatusVisita({ resumo = {}, statusSelecionado, onChange, variante = 'cola-mapa' }) {
  function clicar(key) {
    if (statusSelecionado === key) {
      onChange?.(null);  // toggle off
    } else {
      onChange?.(key);
    }
  }

  return (
    <div className={"legenda-visita " + (variante === "standalone" ? "lv-standalone" : "")}>
      <span className="lv-titulo">Status das OS:</span>

      <span className={'lv-pill' + (!statusSelecionado ? ' active' : '')}
            onClick={() => onChange?.(null)}
            title="Mostrar todas">
        <span className="lv-dot" style={{ background: '#374151' }}></span>
        Todas
      </span>

      {ITENS.map(it => {
        const n = resumo[it.resumoKey] ?? 0;
        const ativo = statusSelecionado === it.key;
        return (
          <span key={it.key}
                className={'lv-pill' + (ativo ? ' active' : '') + (n === 0 ? ' vazio' : '')}
                onClick={() => n > 0 && clicar(it.key)}
                title={`${it.label}: ${n}`}>
            <span className="lv-dot" style={{ background: it.cor }}></span>
            {it.label} ({n})
          </span>
        );
      })}
    </div>
  );
}
